var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-icon',{staticClass:"pointer",attrs:{"icon":"info-circle-fill","id":'uuid-tooltip-' + _vm.value},on:{"click":_vm.saveToClipboard}}),_c('b-tooltip',{attrs:{"target":'uuid-tooltip-' + _vm.value,"placement":"bottom"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }